export const accordion = (btns, cont, items) => {
    if (items.length) {
        btns.forEach(function (item, index) {
            item.addEventListener('click', function () {
                if (items[index].classList.contains('active')) {
                    items[index].classList.remove('active')
                    cont[index].style.maxHeight = '0px';
                } else {
                    cont.forEach(function (subItem, index) {
                        subItem.style.maxHeight = '0px';
                    })
                    items.forEach(function (subItem) {
                        subItem.classList.remove('active');
                    })
                    items[index].classList.add('active');
                    const contHeight = cont[index].scrollHeight;
                    cont[index].style.maxHeight = `${contHeight}px`;
                }
            })
        })
    }
}
